import { render, staticRenderFns } from "./Step3AddToCoverForm.vue?vue&type=template&id=1389a32c&"
import script from "./Step3AddToCoverForm.vue?vue&type=script&lang=js&"
export * from "./Step3AddToCoverForm.vue?vue&type=script&lang=js&"
import style0 from "./Step3AddToCoverForm.vue?vue&type=style&index=0&id=1389a32c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports